// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3todg","colBig":"styles_colBig__2X0rG","colSmall":"styles_colSmall__1_0LU","shopifyNameWrapper":"styles_shopifyNameWrapper__1CElt"};